import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
@Directive({
  selector: '[appCreditCard]'
})
export class CreditCardDirective {
  constructor() { }
  @Input('appCreditCard') date: String;
  @Input() source: string = '';
  @Output() cardType = new EventEmitter();
  @HostListener('keypress', ['$event']) onkeypress(ev) {
    let valid = false;
    if ((ev.charCode >= 48 && ev.keyCode <= 57)) {
      valid = true;
    }
    if ((ev.charCode == 46 || ev.charCode == 44)) {
      valid = true;
    }
    if (!valid) {
      ev.preventDefault();
    }
    if ((ev.charCode >= 8 && ev.keyCode <= 18)) {
      this.cardType.emit('Invalid');
    }
  }
  @HostListener('blur', ['$event']) onblur(event) {
    if (event.target.value != undefined && event.target.value != "") {
      if (event.target.value.length > 14) {
        let expVisa = /^4\d{15}(\d{3})?$/;
        let expMaster = /^5[1-5][0-9]{14}$/;
        let expAmerican = /^3[47][0-9]{13}$/;
        if (expVisa.test(event.target.value)) {
          this.cardType.emit('Visa');
        }
        else if (expMaster.test(event.target.value)) {
          this.cardType.emit('Master');
        }
        else if (expAmerican.test(event.target.value)) {
          this.cardType.emit('American');
        }
        else {
          this.cardType.emit('Invalid');
        }
      }
      if (event.target.value.length < 12) {
        this.cardType.emit('Invalid');
      }
      if ((event.charCode == 46 || event.charCode == 44)) {
        this.cardType.emit('Invalid');
      }
    }
  }
  @HostListener('keyup', ['$event']) onkeyup(event) {
    if (event.target.value != undefined && event.target.value != "") {
      if (event.target.value.length > 14) {
        let expVisa = /^4\d{15}(\d{3})?$/;
        let expMaster = /^5[1-5][0-9]{14}$/;
        let expAmerican = /^3[47][0-9]{13}$/;
        if (expVisa.test(event.target.value)) {
          this.cardType.emit('Visa');
        }
        else if (expMaster.test(event.target.value)) {
          this.cardType.emit('Master');
        }
        else if (expAmerican.test(event.target.value)) {
          this.cardType.emit('American');
        }
        else {
          this.cardType.emit('Invalid');
        }
      }
      if (event.target.value.length < 12) {
        this.cardType.emit('Invalid');
      }
      if ((event.charCode == 46 || event.charCode == 44 || event.charCode == 8)) {
        this.cardType.emit('Invalid');
      }
    }
    else {
      this.cardType.emit('Invalid');
    }
  }
}